import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt'
import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'

import { NAV_BRAND, TRACKING_CONFIGURATION } from '../../config'
import { PORTAL_TYPE_RJA } from '../../config/constants'
import { NavbarActionButton, NavbarUpButton } from '../../generic'
import { ShareLinks } from '../../share/components/Share'
import { share } from '../../share/store/actions'
import * as tracking from '../../tracking'
import { MICROCONVERSION_EVENT_CLICK_SHARE_ARTICLE } from '../../tracking/constants'
import { appendQueryParams } from '../../utils/url'

export const ShareBar = ({ title, url, parenturl: parentUrl }) => {
  const dispatch = useDispatch()

  url = appendQueryParams(url, TRACKING_CONFIGURATION.cmsArticleTrackingParams)
  const escapedUrl = encodeURIComponent(url)
  title = `Spannender Artikel: ${title} - ${NAV_BRAND.portal_name}`

  const onShareLinkClick = event => {
    tracking.trackMicroConversion(MICROCONVERSION_EVENT_CLICK_SHARE_ARTICLE)
  }

  const onShareButtonClick = event => {
    event.preventDefault()
    tracking.trackMicroConversion(MICROCONVERSION_EVENT_CLICK_SHARE_ARTICLE)
    dispatch(share({ url, title })) // expected relative decoded url
  }

  const onBackClick = event => {
    event.preventDefault()
    if (parentUrl) {
      window.location.href = parentUrl
    } else {
      window.history.back()
    }
  }

  const isRja = NAV_BRAND.portal_type === PORTAL_TYPE_RJA
  const fecabookIcon = isRja ? faFacebookSquare : faFacebook

  return (
    <>
      <section className='container cms-block__container cms-section cms-section--sharing-bar d-xl-block'>
        <div className='row'>
          <div className='col'>
            <hr />
            <div className='share-bar'>
              <ShareLinks
                escapedUrl={escapedUrl}
                emailSubject={title}
                onClick={onShareLinkClick}
                facebookIcon={fecabookIcon}
              />
            </div>
            <hr />
          </div>
        </div>
      </section>
      <NavbarUpButton icon={faChevronLeft} onClick={onBackClick} />
      <NavbarActionButton icon={faShareAlt} onClick={onShareButtonClick} />
    </>
  )
}

ShareBar.propTypes = {
  url: PropTypes.string.isRequired,
  parenturl: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default ShareBar
